document.addEventListener('DOMContentLoaded', () => {
  const contactForm = document.querySelector('[data-google-contact]');
  const responseFrame = document.querySelector('[data-google-response]');
  if (contactForm && responseFrame) {
    let submitted = false;
    contactForm.addEventListener('submit', () => {
      submitted = true;
      const button = contactForm.querySelector('button[type="submit"]');
      if (button) { button.disabled = true; button.textContent = '送信中…'; }
    });
    responseFrame.addEventListener('load', () => {
      if (!submitted) return;
      submitted = false;
      contactForm.reset();
      const button = contactForm.querySelector('button[type="submit"]');
      if (button) { button.disabled = false; button.textContent = '問い合わせを送信'; }
      const message = contactForm.querySelector('[data-contact-success]');
      if (message) message.hidden = false;
    });
  }
});
